import _extends from 'babel-runtime/helpers/extends';
import { graphql } from 'react-apollo';
import { ProgressQuery } from '../apollo/progress-graphql';

/**
 * TODO: mimiller thinks we should not use this - it is only used by an admin component currently.
 *   it is better to use the redux store and to explicitly call loadProgress rather than have it
 *   load on connect()
 */
var getProgressActivities = function getProgressActivities(progressData, sequence) {
  if (progressData.loading) return;
  var sequenceId = sequence.sequenceId;

  var sequenceProgress = progressData.progress && progressData.progress.length > 0 ? progressData.progress[0].sequences.find(function (s) {
    return s.sequenceId === sequenceId;
  }) : undefined;
  return sequence.activities.map(function (a) {
    var progress = sequenceProgress ? sequenceProgress.activities.find(function (ap) {
      return ap.activityId === a.activityId;
    }) : undefined;
    return _extends({}, a, { progress: progress });
  });
};

var getSequenceProgress = function getSequenceProgress(data, sequenceId) {
  if (data.loading) return;
  if (!data.progress || data.progress.length === 0) return;
  return data.progress[0].sequences.find(function (s) {
    return s.sequenceId === sequenceId;
  });
};

var queryOptions = {
  options: function options(ownProps) {
    return {
      variables: {
        courseId: ownProps.course ? ownProps.course.courseId : undefined
      }
    };
  },
  props: function props(_props) {
    var progressData = _props.progressData,
        sequence = _props.ownProps.sequence;

    var loaded = !progressData.loading && sequence;

    var sequenceProgress = loaded ? getSequenceProgress(progressData, sequence.sequenceId) : null;
    var activitiesProgress = loaded ? getProgressActivities(progressData, sequence) : null;

    return { sequenceProgress: sequenceProgress, activitiesProgress: activitiesProgress, progressData: progressData };
  },
  name: 'progressData'
};

export var withProgress = graphql(ProgressQuery, queryOptions);